export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '福利导航在线观看是什么？',
    answer: '福利导航在线观看是一个精选资源一站式导航平台，我们汇聚全网优质在线资源，按分类整理，为用户提供便捷的导航服务。无需下载任何软件，直接通过浏览器即可在线观看各类精彩内容。',
  },
  {
    question: '使用福利导航需要付费吗？',
    answer: '完全免费！福利导航在线观看始终坚持以免费服务为核心，所有资源导航服务均不收取任何费用。我们致力于为广大用户提供最便捷、最优质的在线资源导航体验。',
  },
  {
    question: '网站的资源多久更新一次？',
    answer: '我们的内容团队每天都会对网站资源进行更新和维护，确保用户能够及时获取最新的热门资源。同时，我们也会定期清理失效链接，保证导航的准确性和可用性。',
  },
  {
    question: '如何快速找到我想要的资源？',
    answer: '您可以通过首页的分类导航区域快速浏览不同类别的资源。我们也提供了搜索功能，只需输入关键词，即可快速定位到相关内容。此外，首页的热门推荐和最新文章板块也能帮助您发现优质资源。',
  },
  {
    question: '网站支持手机访问吗？',
    answer: '当然支持！福利导航在线观看采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅的浏览和观看体验。',
  },
  {
    question: '如何联系我们提供反馈或建议？',
    answer: '我们非常重视每一位用户的反馈。您可以通过关于我们页面的联系表单提交您的建议和意见，也可以发送邮件至我们的官方邮箱。我们会认真对待每一条反馈，持续优化网站体验。',
  },
];